export enum KatoType {
  OBLAST = 0,
  REGION = 1,
  CITY = 2,
  DISTRICT = 3,
  VILLAGE = 4,
}

export interface IKatoItem {
  kato: number;
  nameRu: string;
  nameKz: string;
  [key: string]: any;
}

export interface IKatoTreeItem {
  kato: number;
  nameRu: string;
  nameKz: string;
  children?: IKatoTreeItem[];
  type?: KatoType;
  statistics?: {
    completed: number;
    completionPercent: number;
    inProcess: number;
    required: number;
    total: number;
  };
}

export interface IBasicStats {
  id: number;
  type:
    | 'ROAD'
    | 'FOOD'
    | 'SER'
    | 'BUDGET'
    | 'MCB'
    | 'EMPLOYMENT'
    | 'LIVESTOCK'
    | 'INFRASTRUCTURE';
  subType: string;
  additionalInfo: Record<string, string | number>;
  currentYearVal: number;
  previousYearVal: number;
  ifo: number;
  ifoPlace: number;
  increaseVal: number;
  volumePlace: number;
}
export interface IBudgetInvestment {
  id: number;
  devType: 'budget_razv' | 'tek_budget';
  plan: number;
  fact: number;
  plan2024: number;
  remoteKato: string;
  typeBudget: 'DEDICATED_REGIONAL_BUDGET' | 'REGIONAL_BUDGET';
}

export interface IBudgetInvestmentProjectStats {
  id: number;
  city: string;
  realizationDate: string;
  quarter: string | null;
  nameRu: string;
  nameKz: string;
  currentPrice: number;
  totalPrice: number;
  currentYearTotalSum: number;
  developmentShare: number;
  rb: number;
  faktsumCurrYear: number;
  percentTekGod: number;
}

export interface IBudgetStats {
  id: number;
  totalProjectCount: number;
  totalBudgetMonthlyPlan: number;
  curBudgetMonthlyPlan: number;
  devBudgetMonthlyPlan: number;
  totalBudgetMonthlyFact: number;
  curBudgetMonthlyFact: number;
  devBudgetMonthlyFact: number;
  totalBudgetAnnualPlan: number;
  curBudgetAnnualPlan: number;
  devBudgetAnnualPlan: number;
  totalBudgetMonthlyProcessing: number;
  curBudgetMonthlyProcessing: number;
  devBudgetMonthlyProcessing: number;
  totalBudgetAnnualProcessing: number;
  curBudgetAnnualProcessing: number;
  devBudgetAnnualProcessing: number;
}

export interface IChildInfo {
  kato: number;
  nameRu: string;
  nameKz: string;
  population: number | string | null;
  distance: number | null;
  area: number | null;
}
export interface IDistrictIncomeStats {
  id: number;
  kato: number;
  nameRu: string;
  nameKz: string;
  date: string;
  periodPlan: number;
  periodFact: number;
  periodImplementation: number;
  annualPlan: number;
  annualFact: number;
  annualImplementation: number;
}

export interface IGeneralInfoDetails {
  population: number | string;
  populationDynamic: number | string;
  avgSalary: number | string;
  area: number | string;
  date: string;
  akimNameRu: string;
  akimNameKz: string;
  akimPositionRu: string;
  akimPositionKz: string;
  akimPhone: string;
  akimImageId: number;
  akimInPositionFrom: string;
  year: number;
}

export interface IPopulationDemandStatCounts {
  id: number;
  kato: number;
  nameRu: string;
  nameKz: string;
  normalConstructionCount: number;
  newConstructionRequirementCount: number;
  constructionRepairRequirementCount: number;
  notProvidedCount: number;
}

export interface IPopulationIncreaseDynamicStats {
  id: number;
  year: number;
  value: number | string;
}

export interface IProductSelfSufficiencyStats {
  id: number;
  previousYearVal: number | null;
  currentYearVal: number | null;
  productNameRu: string;
  productNameKz: string;
  annualConsumptionPerPerson: number;
  annualConsumption: number;
  annualProductProduction: number;
  selfSufficiencyPercentage: number;
  additionalInfo: Record<string, string | number> | null;
}

export interface IProjectEstimateDocumentation {
  category: string;
  totalCount: number;
  governmentInvestorsCount: number;
  nonGovernmentInvestorsCount: number;
  quasiGovernmentInvestorsCount: number;
}

export enum GeneralInfoStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROCESS = 'IN_PROCESS',
  COMPLETED = 'COMPLETED',
}

export interface ITaxStats {
  id: number;
  type: 'REGIONAL_BUDGET' | 'PROPER_REGIONAL_BUDGET';
  fact: number;
  taxRevenuesFact: number;
  nonTaxRevenuesFact: number;
  fixedAssetsSaleFact: number;
  plan: number;
  taxRevenuesPlan: number;
  nonTaxRevenuesPlan: number;
  fixedAssetsSalePlan: number;
  annual: number;
  taxRevenuesAnnual: number;
  nonTaxRevenuesAnnual: number;
  fixedAssetsSaleAnnual: number;
  planPercent: number;
  taxRevenuesPlanPercent: number;
  nonTaxRevenuesPlanPercent: number;
  fixedAssetsSalePlanPercent: number;
  annualPercent: number;
  taxRevenuesAnnualPercent: number;
  nonTaxRevenuesAnnualPercent: number;
  fixedAssetsSaleAnnualPercent: number;
}

export interface IRoad {
  id: number;
  index: string;
  roadName: string;
  totalKm: number;
  prevYearGoodConditionKm: number;
  prevYearGoodConditionPercentage: number;
  prevYearSatisfactoryConditionKm: number;
  prevYearSatisfactoryConditionPercentage: number;
  prevYearPoorConditionKm: number;
  prevYearPoorConditionPercentage: number;
  curYearGoodConditionKm: number;
  curYearGoodConditionPercentage: number;
  curYearSatisfactoryConditionKm: number;
  curYearSatisfactoryConditionPercentage: number;
  curYearPoorConditionKm: number;
  curYearPoorConditionPercentage: number;
  ongoingProjects: string;
}
export interface IRoadShareStats {
  id: number;
  name: string;
  curYearTotalFineRoadPercentage: number;
  prevYearTotalFineRoadPercentage: number;
  totalCurYearGoodConditionKm: number;
  totalCurYearGoodConditionPercentage: number;
  totalCurYearPoorConditionKm: number;
  totalCurYearPoorConditionPercentage: number;
  totalCurYearSatisfactoryConditionKm: number;
  totalCurYearSatisfactoryConditionPercentage: number;
  totalKm: number;
  totalPrevYearGoodConditionKm: number;
  totalPrevYearGoodConditionPercentage: number;
  totalPrevYearPoorConditionKm: number;
  totalPrevYearPoorConditionPercentage: number;
  totalPrevYearSatisfactoryConditionKm: number;
  totalPrevYearSatisfactoryConditionPercentage: number;
  roadsList: IRoad[];
}

export interface ITotalRoadShareStats {
  curYearTotalFineRoadPercentage: number;
  prevYearTotalFineRoadPercentage: number;
  totalCurYearGoodConditionKm: number;
  totalCurYearGoodConditionPercentage: number;
  totalCurYearPoorConditionKm: number;
  totalCurYearPoorConditionPercentage: number;
  totalCurYearSatisfactoryConditionKm: number;
  totalCurYearSatisfactoryConditionPercentage: number;
  totalKm: number;
  totalPrevYearGoodConditionKm: number;
  totalPrevYearGoodConditionPercentage: number;
  totalPrevYearPoorConditionKm: number;
  totalPrevYearPoorConditionPercentage: number;
  totalPrevYearSatisfactoryConditionKm: number;
  totalPrevYearSatisfactoryConditionPercentage: number;
  roadShareStats: IRoadShareStats[];
}

export interface IPopulationDetailsStats {
  id: number;
  populationCount: number;
  maleCount: number;
  femaleCount: number;
  birthCount: number;
  deathCount: number;
  immigrationCount: number;
  emigrationCount: number;
  saldoMigration: number;
  populationEmploymentCount: number;
  economicallyActivePopulation: number;
  youthPopulationCount: number;
  employedPopulationCount: number;
  hiredPopulationCount: number;
  selfEmployedPopulationCount: number;
  unemployedPopulationCount: number;
  naturalCount: number;
}
export interface IGeneralInfo {
  basicStats: IBasicStats[];
  budgetInvestment: IBudgetInvestment[];
  budgetInvestmentProjectStats: IBudgetInvestmentProjectStats[];
  budgetStats: IBudgetStats;
  childInfoList: IChildInfo[];
  districtIncomeStats: IDistrictIncomeStats[];
  generalInfo: IGeneralInfoDetails;
  imageIds: number[];
  kato: number;
  incomeStats?: {
    id: number;
    iframeUrl: string;
    iframeUrlAlt: string;
    kato: number;
  };
  budgetInvIframe?: {
    iframeUrlExp: string;
    iframeUrlAltExp: string;
    kato: number;
  };
  populationDemandStatsCounts: IPopulationDemandStatCounts[];
  populationIncreaseDynamicStats: IPopulationIncreaseDynamicStats[];
  populationDetailsStats: IPopulationDetailsStats;
  productSelfSufficiencyStats: IProductSelfSufficiencyStats[];
  projectEstimateDocumentation: IProjectEstimateDocumentation[];
  status: GeneralInfoStatus;
  taxStats: ITaxStats[];
  totalRoadShareStats: ITotalRoadShareStats;
}

export enum ICardName {
  SER = 'ser',
  PSD = 'psd',
  POPULATION_DYNAMIC = 'population-dynamic',
  BUDGET_INVESTMENT_PROJECTS = 'budget-investment-projects',
  FOOD = 'food',
  INFRASTRUCTURE = 'infrastructure',
  ROAD = 'road',
  TAX = 'tax',
  POPULATION_DEMAND = 'population-demand',
  MEDIA_MONITORING = 'media-monitoring',
}

export enum SerSubtype {
  AGRICULTURE = 'AGRICULTURE',
  CONSTRUCTION = 'CONSTRUCTION',
  HOUSE_COMMISSIONING = 'HOUSE_COMMISSIONING',
  INDUSTRIAL_PRODUCTION = 'INDUSTRIAL_PRODUCTION',
  INVESTMENT = 'INVESTMENT',
  MANUFACTURING_INDUSTRY = 'MANUFACTURING_INDUSTRY',
  MINING_INDUSTRY = 'MINING_INDUSTRY',
  TRANSPORT_WAREHOUSING = 'TRANSPORT_WAREHOUSING',
}

export enum FoodSubType {
  BEEF = 'BEEF',
  LAMB = 'LAMB',
  CHICKEN = 'CHICKEN',
  EGG = 'EGG',
  TOMATO = 'TOMATO',
  MILK = 'MILK',
  POTATO = 'POTATO',
  ONION = 'ONION',
  CUCUMBER = 'CUCUMBER',
  CARROT = 'CARROT',
}

export enum InfrastructureSubType {
  GAS_SUPPLY = 'GAS_SUPPLY',
  WATER_SUPPLY = 'WATER_SUPPLY',
  INTERNET_ACCESS = 'INTERNET_ACCESS',
  MOBILE_COMMUNICATION = 'MOBILE_COMMUNICATION',
}

export interface IMediaMonitoringData {
  id: string;
  text: string;
  textShort: boolean;
  spheres: string[];
  likeSum: number;
  commentSum: number;
  viewSum: number;
  author: string | null;
  followers: number | null;
  audienceSize: number;
  url: string;
  eventName: string;
  socialNet: number | null;
  lang: string;
  tone: number;
  toneText: string;
  bdate: string | null;
  sharedSum: number;
}

export interface IStatistics {
  total: number;
  inProcess: number;
  completed: number;
  required: number;
  completionPercent: number;
}
